import { LightTheme } from 'baseui';
import { Theme as BwTheme } from 'baseui/theme';
import { unsafeCoerce } from 'fp-ts/lib/function';
import { transparentize } from 'polished';
import { DefaultTheme, InterpolationValue, ThemeProps } from 'styled-components';
import { safeKeysOf } from '../util/safeKeysOf';

export type ThemeColourKey = keyof BwTheme['colors'];

type InterpolationProps = ThemeProps<DefaultTheme>;

export const ThemeColours: Record<ThemeColourKey, InterpolationValue> = unsafeCoerce(
  Object.fromEntries(
    safeKeysOf(LightTheme.colors).map(key => [
      key,
      (props: InterpolationProps) => props.theme.colors[key],
    ]),
  ),
);

export const transparentThemeColour = (key: ThemeColourKey, amount: number) => (
  props: InterpolationProps,
) => transparentize(amount, props.theme.colors[key]);
